import React from "react";
import { useNavigate } from "react-router-dom";

function BackIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
      <path
        d="M15 18l-6-6 6-6"
        stroke="#414853"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function CartIcon() {
  return (
    <svg width="19" height="19" viewBox="0 0 24 24" fill="none">
      <path
        d="M3 4h2l2.4 12.2a2 2 0 002 1.8h8.4a2 2 0 002-1.7L21 8H6"
        stroke="#414853"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="10" cy="21" r="1.4" fill="#414853" />
      <circle cx="18" cy="21" r="1.4" fill="#414853" />
    </svg>
  );
}

/**
 * Persistent top bar used across every shop-customer screen: contextual back
 * button on the left, optional title, and a profile chip (avatar initial +
 * first name) on the right that always routes to /shop/profile — the single
 * place basic profile info + order history live. Doubles as the "account
 * entry point" so users never have to hunt for it.
 */
export default function ShopNavBar({
  title,
  onBack,
  hideBack = false,
  showProfile = true,
  cartCount = 0,
  onCart,
}) {
  const navigate = useNavigate();
  const nickname = localStorage.getItem("shopUserNickname") || "";
  const initial = nickname ? nickname[0].toUpperCase() : "?";
  const firstName = nickname ? nickname.split(" ")[0] : "Account";

  return (
    <div className="sticky top-0 z-30 bg-white/95 backdrop-blur border-b border-gray-100 h-[58px] px-2.5 flex items-center justify-between gap-2">
      <div className="flex items-center gap-1 min-w-0">
        {!hideBack ? (
          <button
            onClick={onBack || (() => navigate(-1))}
            className="w-9 h-9 flex items-center justify-center rounded-full active:bg-gray-100 transition-colors shrink-0"
            aria-label="Back"
          >
            <BackIcon />
          </button>
        ) : (
          <div className="w-9 shrink-0" />
        )}
        {title && (
          <p className="font-semibold text-[16px] otaDark truncate">{title}</p>
        )}
      </div>

      <div className="flex items-center gap-1.5 shrink-0">
        {onCart && (
          <button
            onClick={onCart}
            className="relative w-9 h-9 flex items-center justify-center rounded-full active:bg-gray-100 transition-colors"
            aria-label="Cart"
          >
            <CartIcon />
            {cartCount > 0 && (
              <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-[#3969E7] text-white text-[10px] font-bold flex items-center justify-center">
                {cartCount > 9 ? "9+" : cartCount}
              </span>
            )}
          </button>
        )}

        {showProfile && (
          <button
            onClick={() => navigate("/shop/profile")}
            className="flex items-center gap-1.5 pl-1 pr-2.5 py-1 rounded-full active:bg-gray-100 transition-colors"
            aria-label="Profile"
          >
            <span className="w-7 h-7 rounded-full otaGradientButton flex items-center justify-center text-white text-xs font-bold shrink-0">
              {initial}
            </span>
            <span className="text-xs font-semibold otaDark max-w-[70px] truncate">
              {firstName}
            </span>
          </button>
        )}
      </div>
    </div>
  );
}
